import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import char from '../../assets/images/intake/step13/char.svg';
import { useEmploymentReadinessContext } from '../../hooks/use-form-context.hooks';
import {
  ProfessionalResourceStatus,
  dispatchUpdateEmploymentReadiness,
} from '../../redux/slice/form-employment-readiness';
import { useAppDispatch } from '../../redux/store';
import logger from '../../services/logger';

interface FormData {
  professionalEmail: string;
}
interface ComponentProps {
  step: number;
  onBack: () => void;
}

const email_options = [
  {
    label: 'What is a professional email account?',
    value: ProfessionalResourceStatus.WHAT_IS_IT,
  },
  {
    label: 'No',
    value: ProfessionalResourceStatus.NO,
  },
  {
    label: 'I have an email account but it’s not very professional',
    value: ProfessionalResourceStatus.UNPROFESSIONAL,
  },
  {
    label: 'Yes, I have a professional email account',
    value: ProfessionalResourceStatus.YES,
  },
];
export const ProfessionalEmail: React.FC<ComponentProps> = ({ step, onBack }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { professionalEmail } = useEmploymentReadinessContext();
  const [selectedEmailOption, setSelectedEmailOption] = useState(professionalEmail || '');
  const [error, setError] = useState('');
  const handleEmailOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedEmailOption(event.target.value);
    setError('');
  };
  const { handleSubmit } = useForm<FormData>();
  const submitEmailOption: SubmitHandler<FormData> = async () => {
    logger.debug('Submitted professional email form.', selectedEmailOption);

    if (!selectedEmailOption) {
      setError('Please select an option');
    } else {
      const dto: Record<keyof FormData, ProfessionalResourceStatus> = {
        professionalEmail: selectedEmailOption as ProfessionalResourceStatus,
      };
      await dispatch(dispatchUpdateEmploymentReadiness(dto));
      navigate(`/pre-employment/employment-readiness/step${step + 1}`);
    }
  };
  const backButtonClick = () => {
    onBack();
  };

  useEffect(() => {
    if (professionalEmail) {
      setSelectedEmailOption(professionalEmail);
    }
  }, [professionalEmail]);

  return (
    <div>
      <div className="flex items-center mt-9 mb-10 md:px-10">
        <div className="bg-gray-200 p-4 rounded-lg font-semibold mr-5 flex items-center">14</div>
        <div>
          <h4 className="text-2xl">
            I have a<span className="font-semibold"> professional email account </span>
          </h4>
        </div>
      </div>
      <div className="character absolute top-96 right-[-125px] z-[-1]">
        <img className="" src={char} alt="" />
      </div>
      <form
        className="md:px-10"
        action=""
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={handleSubmit(submitEmailOption)}
      >
        <div className="grid gap-y-3">
          {email_options.map((option) => (
            <div key={option.label} className="h-[60px]">
              <label className="radio-container h-full p-4 block relative">
                <input
                  checked={selectedEmailOption === option.value}
                  onChange={handleEmailOptionChange}
                  value={option.value}
                  className="w-full h-full absolute top-0 left-0 opacity-0"
                  type="radio"
                  name="resume option"
                />
                <span className="checkmark !block h-auto pt-4">{option.label}</span>
              </label>
            </div>
          ))}
          {error && <p className="text-red-500">{error}</p>}
        </div>
        <div className="flex justify-between mt-20">
          <button
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleSubmit(backButtonClick)}
            className="btn-primary"
          >
            Back
          </button>
          <button className="btn-primary">Next</button>
        </div>
      </form>
    </div>
  );
};
